import React from 'react';
import { Bell, Package, Tag, Info } from 'lucide-react';
import { motion } from 'framer-motion';
import { Header } from '../components/ui/Header';
const MOCK_NOTIFICATIONS = [{
  id: 1,
  type: 'order',
  title: 'Order Shipped',
  message: 'Your order #ORD-847291 has been shipped and is on its way.',
  time: '2 hours ago',
  unread: true
}, {
  id: 2,
  type: 'promo',
  title: 'Flash Sale Alert! ⚡',
  message: 'Up to 50% off on electronics for the next 24 hours.',
  time: '5 hours ago',
  unread: true
}, {
  id: 3,
  type: 'system',
  title: 'Welcome to JUMMALL',
  message: 'Thanks for joining! Complete your profile to get a 10% discount coupon.',
  time: '1 day ago',
  unread: false
}];
export function NotificationsScreen() {
  const getIcon = (type: string) => {
    switch (type) {
      case 'order':
        return <Package className="w-5 h-5 text-primary" data-id="element-825" />;
      case 'promo':
        return <Tag className="w-5 h-5 text-primary" data-id="element-826" />;
      default:
        return <Info className="w-5 h-5 text-gray-500" data-id="element-827" />;
    }
  };
  const getBg = (type: string) => {
    switch (type) {
      case 'order':
        return 'bg-primary-50';
      case 'promo':
        return 'bg-accent-50';
      default:
        return 'bg-gray-100';
    }
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-gray-50" data-id="element-828">
      <Header title="Notifications" data-id="element-829" />

      <div className="p-4 space-y-3" data-id="element-830">
        {MOCK_NOTIFICATIONS.map(notif => <div key={notif.id} className={`bg-white p-4 rounded-2xl shadow-sm border ${notif.unread ? 'border-primary/20' : 'border-gray-50'} flex gap-4 relative overflow-hidden`} data-id="element-831">
            {notif.unread && <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary" data-id="element-832"></div>}
            <div className={`w-12 h-12 rounded-full flex items-center justify-center shrink-0 ${getBg(notif.type)}`} data-id="element-833">
              {getIcon(notif.type)}
            </div>
            <div data-id="element-834">
              <div className="flex justify-between items-start gap-2 mb-1" data-id="element-835">
                <h3 className={`font-bold text-sm ${notif.unread ? 'text-gray-900' : 'text-gray-700'}`} data-id="element-836">
                  {notif.title}
                </h3>
                <span className="text-xs text-gray-400 shrink-0 whitespace-nowrap" data-id="element-837">
                  {notif.time}
                </span>
              </div>
              <p className="text-sm text-gray-600 leading-snug" data-id="element-838">
                {notif.message}
              </p>
            </div>
          </div>)}
      </div>
    </motion.div>;
}